// curly braces means to import only the `JSO` method from this module.
var ClientOAuth2 = require('client-oauth2');
import ApiService from "@/apiService.js";
//let sso = require('./config.json').sso;

//config details taken from doc: https://github.com/andreassolberg/jso
//Use PCF SSO manager to get the below credentials for this app
const client = new ClientOAuth2({
  providerID: 'gx',
  client_id: 'b02bf903-fd46-47d9-87fa-76a803d16240',
  //redirect_uri: 'https://lvh.me:8080/',
  authorization: 'https://geoaxis.login.system.devom.east.paas.nga.mil/oauth/authorize',
  //redirect_uri: 'https://fgs-dps.dev.gs.mil/'
  redirect_uri: 'http://fgs-dps.devom.east.paas.nga.mil'
});

//Create functions that contain some available JSO methods to plug into the UI
export default {
  authLogin() {
    return client.getToken();
  },
  async authLogOut() {
    return await client.wipeTokens();
  },
  async authCallBack() {
    return await client.callback();
  },
  async getToken() {
    return await client.getToken();
  },
  async getBearerToken() {
    const token = await this.getToken();
    if (token) {
      return token.access_token;
    } else {
      return null
    }
  },
  getBearerTokenFromLocalStorage() {
    if (localStorage.getItem('tokens-gx')) {
      return JSON.parse(localStorage.getItem('tokens-gx'))[0].access_token;
    }
    return null
  },
  async checkIfUserIsAdmin() {
    const ssoUser = await ApiService.getUserInfo();
    const adminTableCheck = await ApiService.checkAdminStatus(ssoUser.user_id);
    let results = adminTableCheck.data[0].count;
    if (results == 1)
      return true;
    else
      return false;
  },
  async getValidAuthToken() {
    // gets a token from local storage if it exists, if not gets a new token from geoaxis and then sets the axios Authorization header with the token
    // then we validate the token against the aqfs api so that it will establish an API session
    let token = null;
    try {
      token = await this.getToken();
      ApiService.setAxiosDefaults(token.access_token);
      if (!(await this.isTokenValid())) {
        token = null;
      }
    } catch (e) {
      console.error('Could Not Retrieve Auth Token - Geoaxis Might Be Down')
    }
    return token
  },
  async isTokenValid() {
    try {
      // if we can get a user profile from geoaxis then the token is valid
      await ApiService.getUserInfo();
      return true;
    } catch (e) {
      console.error('Token Is Not Valid');
      return false;
    }
  },
  async isGeoaxisUp() {
    try {
      const response = await ApiService.getGeoaxisStatus();
      if (response.status === 200) {
        return true;
      }
      return false;
    } catch (e) {
      console.error('Geoaxis Appears To Be Down! - ' + e);
      return false;
    }
  }
}

